import * as e from "react";
import a from "../lib/SSRBase.es.js";
import m from "../defs/Envelope.es.js";
const o = e.forwardRef((r, t) => /* @__PURE__ */ e.createElement(a, { ref: t, ...r, weights: m }));
o.displayName = "EnvelopeIcon";
const s = o;
export {
  s as Envelope,
  o as EnvelopeIcon
};
